<script lang="ts" setup>
import { useVirtualList } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import ConversationListItem from '#nora-chat-ui/components/sidebar/sidebar-items/ConversationListItem.vue';
import { useConversationStore } from '#nora-chat-ui/stores/conversation/conversation-store';

const conversationStore = useConversationStore();
const { sortedConversation } = storeToRefs(conversationStore);
const { t } = useI18n();

const { list, containerProps, wrapperProps } = useVirtualList(
  sortedConversation,
  {
    itemHeight: 80,
  },
);
</script>

<template>
  <div class="overflow-y-auto h-full" v-bind="containerProps">
    <div v-bind="wrapperProps">
      <ConversationListItem
        v-for="{ data } in list"
        :key="data.conversationListResult.id"
        :conversation-state="data"
      />
    </div>
    <div v-if="list.length === 0" class="pt-4">
      <p class="text-[#8EA7B8] text-center">
        {{ t('conversation.noConversationsForYou') }}
      </p>
    </div>
  </div>
</template>
